import { client } from './api-client';

// User devices information
export const fetchGetDevices = () => client.get(`devices`);

export const removeDevice = (body) => client.patch(`devices`, body);
